/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbResultatTypeBulletinSession2GridDto } from './FcbResultatTypeBulletinSession2GridDto';
import {
    FcbResultatTypeBulletinSession2GridDtoFromJSON,
    FcbResultatTypeBulletinSession2GridDtoFromJSONTyped,
    FcbResultatTypeBulletinSession2GridDtoToJSON,
} from './FcbResultatTypeBulletinSession2GridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbResultatTypeBulletinSession2GridDtoPaginatedResults
 */
export interface FcbResultatTypeBulletinSession2GridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbResultatTypeBulletinSession2GridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbResultatTypeBulletinSession2GridDto>}
     * @memberof FcbResultatTypeBulletinSession2GridDtoPaginatedResults
     */
    results?: Array<FcbResultatTypeBulletinSession2GridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbResultatTypeBulletinSession2GridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbResultatTypeBulletinSession2GridDtoPaginatedResults interface.
 */
export function instanceOfFcbResultatTypeBulletinSession2GridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbResultatTypeBulletinSession2GridDtoPaginatedResultsFromJSON(json: any): FcbResultatTypeBulletinSession2GridDtoPaginatedResults {
    return FcbResultatTypeBulletinSession2GridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbResultatTypeBulletinSession2GridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbResultatTypeBulletinSession2GridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbResultatTypeBulletinSession2GridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbResultatTypeBulletinSession2GridDtoPaginatedResultsToJSON(value?: FcbResultatTypeBulletinSession2GridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbResultatTypeBulletinSession2GridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

